import { useQuery } from '@tanstack/react-query'

import config from '@config'
import {
  EntityType,
  followedSportEntitySorter,
  SportEntityType,
} from '@utils/entities'

type UseEntitySubscriptionsProps = {
  enabled?: boolean
  entityType: EntityType
} & { signal?: AbortSignal }

export type SportEntitySubscription = SportEntityType & {
  channel: string | null
}

export type SportEntitySubscriptionsAPIResponse = SportEntitySubscription[]

const {
  nemosyne: { baseUrl, getAllEntitySubscriptionsUrl },
} = config

const fetchEntitySubscriptionsData = async ({
  entityType,
  signal,
}: UseEntitySubscriptionsProps) => {
  const response = await fetch(
    `${baseUrl}${getAllEntitySubscriptionsUrl.replace('{ENTITY_TYPE}', entityType)}`,
    {
      credentials: 'include',
      signal,
    },
  )

  if (!response.ok) {
    throw new Error('Error fetching entity subscriptions data.')
  }

  const jsonResponse = await response.json()

  if (!Array.isArray(jsonResponse)) {
    throw new Error('Invalid response from server')
  }

  return jsonResponse.sort(
    followedSportEntitySorter,
  ) as unknown as Promise<SportEntitySubscriptionsAPIResponse>
}

const useSportEntitySubscriptions = ({
  enabled,
  entityType,
}: UseEntitySubscriptionsProps) => {
  return useQuery({
    queryKey: ['sport-entity-subscriptions', entityType],
    queryFn: async ({ signal }) =>
      fetchEntitySubscriptionsData({
        entityType,
        signal,
      }),
    enabled,
  })
}

export default useSportEntitySubscriptions
